import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router)
var routes=[
	{
		path: '/login',
		name: 'login',
		component: both("login"),
	},
	{
		path: '/template',
		name: 'template',
		component: both("template"),
	},
	{
		path: '/',
		name: '',
		component: both("Home"),
		children: [
			{
				path: 'index',
				component: both("index"),
				name: '首页'
			}
		],
	},
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js